import ActiveStationActions from '../../actions/active_station_actions';

function prepareInitialStation(initialStation) {
    if (initialStation) {
        ActiveStationActions.setActiveStationAction(initialStation, false);
    }
}

export default prepareInitialStation;